export default function (Alpine) {

    Alpine.store('callForm', {
        open: false,
        show() { this.open = true },
        close() { this.open = false }
    });

    Alpine.store('calculatorData', {
        data: {},

        set(payload) {
            this.data = payload
        },

        get() {
            return this.data
        },

        clear() {
            this.data = {}
        }
    });

}
